import { useMutation } from "@tanstack/react-query";
import axios from "axios";

// Define the mutation function separately for clarity
const submitWaitlistFn = async (formData) => {
  // Construct request payload as per WaitlistRequest structure
  const waitlistPayload = {
    first_name: formData.firstName,
    last_name: formData.lastName,
    email: formData.email,
    num_users: parseInt(formData.userCount, 10),
    using_crm: formData.useCRM === "yes", // converts 'yes' to true, 'no' to false
    crm_name: "", // optional, not provided by the form
    additional_notes: formData.notes,
  };

  // Determine the base URL for the API internal endpoint (fallback to empty if not defined)
  const endpoint = `https://lysto-dtctbse3drdvhed6.eastus2-01.azurewebsites.net/waitlist`;

  const response = await axios.post(endpoint, waitlistPayload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export function useSubmitWaitlist() {
  // Explicitly pass the mutation function
  return useMutation({
    mutationFn: submitWaitlistFn,
  });
}

export default useSubmitWaitlist;
